module.exports = __webpack_public_path__ + "img/gartek-portfolio-hospitality-recreation.996dd50c.jpeg";